// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const PurchaseRequestSourceTypeValues = [
	"MANUAL",
	"CUSTOMER_ORDER_LINE",
	"SHOP_ORDER_LINE",
	"PROJECT_STAGE",
	"WAREHOUSE_TRANSFER",
] as const;

export type PurchaseRequestSourceType = (typeof PurchaseRequestSourceTypeValues)[number];

export const getPurchaseRequestSourceTypeLabels = () => ({
	MANUAL: t("manual"),
	CUSTOMER_ORDER_LINE: t("customer_order_line"),
	SHOP_ORDER_LINE: t("shop_order_line"),
	PROJECT_STAGE: t("project_stage"),
	WAREHOUSE_TRANSFER: t("warehouse_transfer"),
});

export const getPurchaseRequestSourceTypeLabel = (value: PurchaseRequestSourceType): string => {
	return getPurchaseRequestSourceTypeLabels()[value];
};
